// removed by extract-text-webpack-plugin
module.exports = {"black":"#000000","purple":"_3_X-_zoGOnezsY514Wkg6D","white":"_3c0Q98xS2NxlDNnkUJI-I8","grey":"#707070","medium-grey":"#9f9f9f","light-grey":"#d4d4d4","tooltip":"Cz1qv62cvn7UabRSnh4k2","defaultOpen":"dE5ssARdHjimkLymV0Ovw","innerBlock":"_1bK2lngNO1DPmG-_bKeeGr","arrow":"CXCEfw34_lwFAzR8ODDid","closeButton":"_2enpGJoecj82RoqmXbB0yD"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/elements/Tooltip/Tooltip.css
// module id = 555
// module chunks = 0